import type { ButtonModel, EditoProductPushModel } from '~/integrations/contentful/src/types';

export const getButtonsWithSkuLinks = (sectionData: EditoProductPushModel, sku: string): ButtonModel[] => {
  const items = sectionData?.buttonCollection?.items?.filter((i) => i) || [];
  if (!sku) return items;

  return items.map((item) => {
    if (!item.link) {
      return {
        ...item,
        link: '#addToCart:' + sku
      };
    }

    return item;
  });
};
